<template>
  <div>
    <prototype-attribute-table
      ref="attributeTable"
      attribute-name="factories"
      :headers="headers"
      :sort-desc="false">
      <template v-slot:[`item.capacitySettings`]="{ item }">
        <v-btn
          small
          text
          color="primary"
          @click="openCapacitySettings(item)">
          <v-icon
            left
            small>
            mdi-tune
          </v-icon>
          Configure
        </v-btn>
      </template>
    </prototype-attribute-table>
    <factory-capacity-settings-dialog
      v-model="capacitySettingsOpen"
      :factory="selectedFactory"
      @saved="onCapacitySettingsSaved" />
  </div>
</template>

<script>
import PrototypeAttributeTable from '../components/PrototypeAttributeTable.vue'
import FactoryCapacitySettingsDialog from '../components/FactoryCapacitySettingsDialog.vue'

export default {
  components: {
    PrototypeAttributeTable,
    FactoryCapacitySettingsDialog
  },
  data () {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name',
          width: 200,
          sortable: false
        },
        {
          text: 'Factory Timeline',
          value: 'factoryTimeline',
          width: 350,
          sortable: false
        },
        {
          text: 'Capacity Settings',
          value: 'capacitySettings',
          width: 200,
          sortable: false
        }
      ],
      capacitySettingsOpen: false,
      selectedFactory: null
    }
  },
  methods: {
    openCapacitySettings (factory) {
      this.selectedFactory = factory
      this.capacitySettingsOpen = true
    },
    onCapacitySettingsSaved () {
      this.capacitySettingsOpen = false
      this.$refs.attributeTable.refresh()
    }
  }
}
</script>
